import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

interface ArrowIconProps {
  isExpanded?: boolean
  className?: string
}

export default function ArrowIcon({ isExpanded = false, className = '' }: ArrowIconProps) {
  return (
    <svg
      className={clsx(styles.arrowIcon, { [styles.expanded]: isExpanded }, className)}
      viewBox='0 0 24 24'
      width='24'
      height='24'
      fill='currentColor'
    >
      <path d='M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z' />
    </svg>
  )
}
